import { useQuery } from "@tanstack/react-query";
import { Button, Card, CardContent, Spinner } from "@learn-me/ui";
import { FileText, Download } from "lucide-react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { materialsApi } from "@/features/materials/api/materialsApi";

export default function MyMaterialsPage() {
  const { data: materials, isLoading } = useQuery({
    queryKey: ["my-materials"],
    queryFn: () => materialsApi.listMyMaterials(),
  });

  const handleDownload = async (materialId: string, filename: string) => {
    try {
      await materialsApi.downloadMaterial(materialId, filename);
    } catch {
      toast.error("No se pudo obtener el archivo");
    }
  };

  return (
    <div className="container py-8">
      <h1 className="text-2xl font-bold mb-6">Mis Materiales</h1>

      {isLoading ? (
        <div className="flex justify-center py-16">
          <Spinner size="lg" />
        </div>
      ) : !materials || materials.length === 0 ? (
        <div className="text-center py-16">
          <p className="text-muted-foreground mb-4">
            Aún no has comprado materiales digitales.
          </p>
          <Link to="/materiales">
            <Button>Explorar materiales</Button>
          </Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {materials.map(({ purchaseId, material }) => (
            <Card key={purchaseId} className="h-full">
              <CardContent className="p-4">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-12 h-12 rounded bg-muted flex items-center justify-center flex-shrink-0">
                    <FileText className="h-6 w-6 text-muted-foreground" />
                  </div>
                  <h3 className="font-semibold line-clamp-2">
                    {material.title}
                  </h3>
                </div>
                <Button
                  className="w-full"
                  onClick={() =>
                    handleDownload(
                      material.id,
                      material.fileName || material.title,
                    )
                  }
                >
                  <Download className="h-4 w-4 mr-2" />
                  Descargar
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
